<template>
  <div>
    <div v-if="allDataLoaded">
      <template v-if="userType === 'customer'">
        <div class="top-content-bar">
          <div class="wrapper dashboard-top-panel customer-dashboard">
            <div class="plain-card full-width">
              <div class="flex">
                <div class="dashboard-card-icon mr-2">
                  <f-icon
                    name="star" />
                </div>
                <h2 class="heading-bigger my-auto">{{ $t('dashboard.welcomeToPanel') }}</h2>
              </div>

              <div class="buttons-container flex mt-3">
                <f-button
                  theme="dashboard"
                  @click.prevent="$router.push({ path: '/oferty-kredytowe/nowa' });"
                  class="flex flex-align-items-center">
                  <f-icon
                    name="edit"
                    class="mr-1" />
                  <span class="button-text">{{ $t('dashboard.newOffer') }}</span>
                </f-button>

                <f-button
                  theme="dashboard"
                  @click.prevent="$router.push({ path: '/oferty-kredytowe' });"
                  class="flex flex-align-items-center">
                  <f-icon
                    name="inquiry"
                    class="mr-1" />
                  <span class="button-text">{{ $t('dashboard.myOffers') }}</span>
                </f-button>

                <f-button
                  theme="dashboard"
                  @click.prevent="$router.push({ path: '/wiadomosci' });"
                  class="flex flex-align-items-center">
                  <f-icon
                    name="mail"
                    class="mr-1" />
                  <span class="button-text">{{ $t('dashboard.myMessage') }}</span>
                </f-button>

                <f-button
                  theme="dashboard"
                  @click.prevent="$router.push({ path: '/ustawienia' });"
                  class="flex flex-align-items-center">
                  <f-icon
                    name="users"
                    class="mr-1" />
                  <span class="button-text">{{ $t('dashboard.mySettings') }}</span>
                </f-button>
              </div>
            </div>
          </div>
        </div>

        <div class="wrapper mt-5">
          <h3 class="heading-small mt-3 mb-1">{{ $t('dashboard.waitingMessage') }}</h3>
          <messages-list
            :withFilters="false"
            :hasPagination="false"
            :routePath="'wiadomosci'"
            :requestWhere="{ needs_answer: 1}"/>

          <h3 class="heading-small mt-4 mb-1">{{ $t('dashboard.offeringsRequiringInteraction') }}</h3>
          <inquiries-list
            :withFilters="false"
            :hasPagination="false"
            :requestWhere="{ needs_answer: 1}"
            :listSource="'customer/inquiries/items'" />
        </div>
      </template>

      <template v-if="userType === 'adviser'">
        <div class="top-content-bar">
          <div class="wrapper dashboard-top-panel">
            <div
              v-if="userHasCustomersAccess"
              class="dashboard-top-panel-element">
              <div class="plain-card plain-card-customers">
                <div class="flex">
                  <div class="dashboard-card-icon mr-2 hidden-mobile-tiny">
                    <f-icon
                      name="users" />
                  </div>
                  <div class="flex flex-column">
                    <h2 class="heading-bigger mt-auto">{{ $t('client.clients') }}</h2>
                    <span class="text-grey-light text-medium-light mb-auto">{{ customers.customers_count.length }} {{ $t('dashboard.customersAcquired') }}</span>
                  </div>

                  <div class="ml-auto">
                    <v-select
                      class="minimal"
                      :options="customerCountOptions"
                      v-model="customerCounterSelected"
                      :reduce="(value) => value.value"
                      :clearable="false"
                      label="label">
                    </v-select>

                    <div class="big-counter">
                      <template v-if="customerCounterSelected === 'days30'">
                        +{{ customers.last_30_days_customers_count }}
                      </template>
                      <template v-else>
                        +{{ customers.last_7_days_customers_count }}
                      </template>
                    </div>
                  </div>
                </div>

                <div class="flex flex-justify-content-between mt-3 flex-wrap">
                  <f-button
                    theme="dashboard"
                    :disabled="!customers.needs_answer_count"
                    @click.prevent="$router.push({ path: '/klienci', query: { needs_answer: 1 } });"
                    class="flex flex-align-items-center mb-1">
                    <f-message-counter
                      big
                      :item="{
                        counter: customers.needs_answer_count,
                        type: 'check_circle',
                      }"
                      class="mr-1"/>
                    <span class="button-text">{{ $t('dashboard.requiredInteractions') }}</span>
                  </f-button>

                  <f-button
                    theme="dashboard"
                    :disabled="!customers.customers_count"
                    @click.prevent="$router.push({ path: '/klienci' });"
                    class="flex flex-align-items-center mb-1">
                    <f-message-counter
                      big
                      :item="{
                        counter: customers.customers_count,
                        type: 'list',
                        read: true
                      }"
                      class="mr-1"/>
                    <span class="button-text">{{ $t('client.fullClientsList') }}</span>
                  </f-button>
                </div>
              </div>
            </div>
            <div
              v-if="userHasInquiriessAccess"
              class="dashboard-top-panel-element ml-2 ml-0-md">
              <div class="plain-card plain-card-inquiries">
                <div class="flex">
                  <div class="dashboard-card-icon mr-2 hidden-mobile-tiny">
                    <f-icon
                      name="inquiry" />
                  </div>
                  <div>
                    <h2 class="heading-bigger " v-pure-html="$t('dashboard.creditsOffers')"></h2>
                    <span class="text-grey-light text-medium-light">{{ inquiries.inquiries_count.length }} {{ $t('dashboard.sendOffers') }}</span>
                  </div>
                  <div class="ml-auto">
                    <v-select
                      class="minimal"
                      :options="inquiriresCountOptions"
                      v-model="inquiriresCounterSelected"
                      :reduce="(value) => value.value"
                      :clearable="false"
                      label="label">
                    </v-select>

                    <div class="big-counter">
                      <template v-if="inquiriresCounterSelected === 'days30'">
                        +{{ inquiries.last_30_days_inquiries_count }}
                      </template>
                      <template v-else>
                        +{{ inquiries.last_7_days_inquiries_count }}
                      </template>
                    </div>

                  </div>
                </div>

                <div class="flex flex-justify-content-between mt-3 flex-wrap">
                  <f-button
                    theme="dashboard"
                    :disabled="!inquiries.needs_answer_count"
                    @click.prevent="$router.push({ path: '/oferty-kredytowe', query: { needs_answer: 1} });"
                    class="flex flex-align-items-center f-btn f-btn-dashboard mb-1">
                    <f-message-counter
                      big
                      :item="{
                        counter: inquiries.needs_answer_count,
                        type: 'check_circle',
                      }"
                      class="mr-1 "/>
                    <span class="button-text">{{ $t('dashboard.requiredInteractions') }}</span>
                  </f-button>

                  <f-button
                    theme="dashboard"
                    :disabled="!inquiries.inquiries_count"
                    @click.prevent="$router.push({ path: '/oferty-kredytowe' });"
                    class="flex flex-align-items-center mb-1">
                    <f-message-counter
                      big
                      :item="{
                        counter: inquiries.inquiries_count,
                        type: 'list',
                        read: true
                      }"
                      class="mr-1"/>
                    <span class="button-text">{{ $t('dashboard.fullOffersList') }}</span>
                  </f-button>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="wrapper mt-5 mb-4 dashboard-charts flex flex-justify-content-between flex-wrap">
          <div class="dashboard-charts-card mr-auto mb-4-md">
            <h3 class="heading-small">{{ $t('dashboard.currentCustomersServed') }}</h3>
            <div
              :class="{
                'dashboard-chart-wrapper mt-1': true,
                'flex': !userHasCustomersAccess
              }">
              <div
                v-if="userHasCustomersAccess"
                class="px-2 py-2">
                <canvas id="customersChart" width="100%" height="455px"></canvas>
              </div>
              <f-alert
                v-else
                visible
                class="text-center"
                theme="inactive">
                <span>
                {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
                </span>
              </f-alert>
            </div>

          </div>

          <div class="dashboard-charts-card mb-4-md">
            <h3 class="heading-small">{{ $t('dashboard.activeCreditsOffers') }}</h3>
            <div
              :class="{
                'dashboard-chart-wrapper mt-1': true,
                'flex': !userHasInquiriessAccess
              }">
              <div
                v-if="userHasInquiriessAccess"
                class="px-2 py-2">
                <canvas id="inquiriesChart" width="100%"  height="455px"></canvas>
              </div>
              <f-alert
                v-else
                visible
                class="text-center"
                theme="inactive">
                <span>
                {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
                </span>
              </f-alert>
            </div>

          </div>

          <div class="dashboard-charts-card ml-auto">
            <h3 class="heading-small">{{ $t('ui.calendar') }}</h3>
            <div
              :class="{
                'dashboard-chart-wrapper mt-1': true,
                'flex': !$store.getters.getUserHasFeature('calendar')
              }">
              <calendar
                v-if="$store.getters.getUserHasFeature('calendar')"
                class="full-height"
                :minimal="true" />
              <f-alert
                v-else
                visible
                class="text-center"
                theme="inactive">
                <span>
                {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
                </span>
              </f-alert>
            </div>
          </div>
        </div>

        <div class="wrapper mt-3">
          <h3 class="heading-small mt-3 mb-1">{{ $t('dashboard.pendingTasksCustomer') }}</h3>
          <template v-if="userHasCustomersAccess">
            <customers-list
              :withFilters="false"
              :hasPagination="false"
              :listField="'invited_count'"
              :itemsList="customers.latest_customers"  />

            <div class="my-2 text-center">
              <router-link
                to='/klienci'
                class="lnk lnk-arrow">
                {{ $t('client.fullClientsList') }}
              </router-link>
            </div>
          </template>
          <template v-else>
            <f-alert
              visible
              class="mt-1 mb-2"
              theme="inactive">
              <span>
              {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
              </span>
            </f-alert>
          </template>

          <h3 class="heading-small mt-3 mb-1">{{ $t('dashboard.pendingTasksCreditsOffers') }}</h3>
          <template v-if="userHasInquiriessAccess">
            <inquiries-list
              :withFilters="false"
              :hasPagination="false"
              :itemsList="inquiries.latest_inquiries" />

            <div class="my-2 text-center">
              <router-link
                to='/oferty-kredytowe'
                class="lnk lnk-arrow">
                {{ $t('dashboard.fullOffersList') }}
              </router-link>
            </div>
          </template>
          <template v-else>
            <f-alert
              visible
              class="mt-1 mb-2"
              theme="inactive">
              <span>
              {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
              </span>
            </f-alert>
          </template>

          <h3 class="heading-small mt-3 mb-1">{{ $t('opinion.newOpinions') }}</h3>
          <template v-if="$store.getters.getUserHasFeature('comments')">
            <opinions-list
            :onDashboard="true" />

            <div class="my-2 text-center">
              <router-link
                to='/opinie'
                class="lnk lnk-arrow">
                {{ $t('ui.seeAll') }}
              </router-link>
            </div>
          </template>
          <template v-else>
            <f-alert
              visible
              class="mt-1 mb-2"
              theme="inactive">
              <span>
              {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
              </span>
            </f-alert>
          </template>
        </div>
      </template>
    </div>
    <div
      v-if="!allDataLoaded && !loadError"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
    <div class="wrapper mt-3">
      <f-alert
        v-if="loadError"
        visible
        theme="warning">
        {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
      </f-alert>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Chart from 'chart.js/auto';
import FormUtils from '@/utils/FormUtils.js';
import InquiriesList from '@/views/lists/InquiriesList.vue';
import CustomersList from '@/views/lists/CustomersList.vue';
import MessagesList from '@/views/lists/MessagesList.vue';
import OpinionsList from '@/views/lists/OpinionsList.vue';
import Calendar from '@/views/Calendar.vue';

export default {
  name: 'dashboard',
  components: {
    'inquiries-list': InquiriesList,
    'customers-list': CustomersList,
    'messages-list': MessagesList,
    'opinions-list': OpinionsList,
    'calendar': Calendar
  },
  computed: {
    allDataLoaded () {
      if (this.userType === 'adviser') {
        let isCustomersLoaded = this.userHasCustomersAccess ? this.customersLoaded : true;
        let isInuiriesLoaded = this.userHasInquiriessAccess ? this.inquiriesLoaded : true;
        return isCustomersLoaded && isInuiriesLoaded;
      }

      return true;
    },
    maxCustomersChartVal () {
      return (Math.max(this.customers.customers_count, this.customers.invitation_confirmed_count, this.customers.invited_count) + 5);
    },
    maxInquiriesChartVal () {
      return (Math.max(this.inquiries.inquiries_count, this.inquiries.last_7_days_inquiries_count, this.inquiries.last_30_days_inquiries_count) + 5);
    },
    customersCtx () {
      if (document.getElementById('customersChart')) {
        return document.getElementById('customersChart').getContext('2d');
      }

      return null;
    },
    inquiriesCtx () {
      if (document.getElementById('inquiriesChart')) {
        return document.getElementById('inquiriesChart').getContext('2d');
      }

      return null;
    },
    customersChartData () {
      return {
        labels: [''],
        datasets: [
          {
            label: `${this.customers.invited_count} ${this.$t('dashboard.inviteClients')}`,
            backgroundColor: '#FB8500',
            data: [this.customers.invited_count],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
          {
            label: `${this.customers.invitation_confirmed_count} ${this.$t('dashboard.acceptedClients')}`,
            backgroundColor: '#0BBB66',
            data: [this.customers.invitation_confirmed_count],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
          {
            label: `${this.customers.customers_count} ${this.$t('dashboard.allCustomers')}`,
            backgroundColor: '#023047',
            data: [this.customers.customers_count],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          }
        ]
      }
    },
    inquiriesChartData () {
      return {
        labels: [''],
        datasets: [
          {
            label: `${this.inquiries.statuses.NEW} ${this.$t('dashboard.newOffers')}`,
            backgroundColor: '#023047',
            data: [this.inquiries.statuses.NEW],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
          {
            label: `${this.inquiries.statuses.UNFINISHED_FORM} ${this.$t('dashboard.uncompletedOffers')}`,
            backgroundColor: '#ABC8D6',
            data: [this.inquiries.statuses.UNFINISHED_FORM],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
          {
            label: `${this.inquiries.statuses.WAITING_FOR_OFFER} ${this.$t('dashboard.waitOffers')}`,
            backgroundColor: '#FFF',
            borderColor: '#FB8500',
            borderWidth: 3,
            data: [this.inquiries.statuses.WAITING_FOR_OFFER],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
          {
            label: `${this.inquiries.statuses.SENT} ${this.$t('dashboard.sendOffers')}`,
            backgroundColor: '#0BBB66',
            data: [this.inquiries.statuses.SENT],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
          {
            label: `${this.inquiries.statuses.CANCELLED} ${this.$t('dashboard.cancelledOffers')}`,
            backgroundColor: '#FFF',
            borderColor: '#E0211B',
            borderWidth: 3,
            data: [this.inquiries.statuses.CANCELLED],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
          {
            label: `${this.inquiries.statuses.REALIZED} ${this.$t('dashboard.completedOffers')}`,
            backgroundColor: '#E0211B',
            data: [this.inquiries.statuses.REALIZED],
            maxBarThickness: 20,
            categoryPercentage: 0.38,
          },
        ]
      }
    },
    userHasCustomersAccess () {
      return this.$store.getters.getUserHasFeature('customers');
    },
    userHasInquiriessAccess () {
      return this.$store.getters.getUserHasFeature('inquiries');
    }
  },
  watch: {
    userHasCustomersAccess (newValue) {
      if (newValue && !this.customersInitiated) {
        this.loadCustomers();
      }
    },
    userHasInquiriessAccess (newValue) {
      if (newValue && !this.inquiriesInitiated) {
        this.loadInquiries();
      }
    }
  },
  data() {
    return {
      userType: null,
      loadError: false,
      customers: [],
      customersLoaded: false,
      customersInitiated: false,
      inquiries: [],
      inquiriesLoaded: false,
      inquiriesInitiated: false,
      opinions: [],
      opinionsLoaded: false,
      customerCountOptions: [
        {
          label: this.$t('dashboard.lastThirtyDays'),
          value: 'days30'
        },
        {
          label: this.$t('dashboard.lastSevenDays'),
          value: 'days7'
        }
      ],
      customerCounterSelected: 'days30',
      inquiriresCountOptions: [
        {
          label: this.$t('dashboard.lastThirtyDays'),
          value: 'days30'
        },
        {
          label: this.$t('dashboard.lastSevenDays'),
          value: 'days7'
        }
      ],
      inquiriresCounterSelected: 'days30',
      customersChart: null,
      inquiriesChart: null,
      optionsAnimations: {
        tension: {
          duration: 1000,
          easing: 'ease-out',
          from: 1,
          to: 0,
          loop: true
        }
      },
      optionsPlugins: {
        legend: {
          maxWidth: 500,
          align: 'start',
          labels: {
            borderWidth: 3,
            boxHeight: 11,
            boxWidth: 11,
            color: '#023047',
            pointStyle: 'rectRounded',
            usePointStyle: true,
            font: {
              family: 'Metropolis',
              size: 12,
              weight: '500'
            }
          }
        }
      }
    };
  },
  mounted () {
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    if (this.$store.getters['getUserType'].toLowerCase() === 'adviser') {
      if (this.userHasCustomersAccess && !this.customersInitiated) {
        this.loadCustomers();
      }

      if (this.userHasInquiriessAccess && !this.inquiriesInitiated) {
        this.loadInquiries();
      }
    }
  },
  methods: {
    loadInquiries () {
      Vue.set(this, 'inquiriesInitiated', true);

      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/adviser/dashboard/inquiries',
        method: 'get',
        outputKey: 'inquiries',
        loadedKey: 'inquiriesLoaded',
        errorKey: 'loadError',
        successAction: () => {
          setTimeout(() => {
            Vue.set(this, 'inquiriesChart', new Chart(this.inquiriesCtx, {
              type: 'bar',
              data: this.inquiriesChartData,
              options: {
                animations: this.optionsAnimations,
                animation: {
                  onComplete: () => {
                    let ctx = this.inquiriesChart.ctx;

                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    ctx.font = '500 16px Metropolis';
                    ctx.fillStyle = '#023047';

                    this.inquiriesChartData.datasets.forEach((dataset, i) => {
                      let meta = this.inquiriesChart.getDatasetMeta(i);
                      meta.data.forEach((bar, index) => {
                        let data = dataset.data[index];
                        ctx.fillText(data, bar.x, bar.y - 10);
                      });
                    });
                  }
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  y: {
                    display: true,
                    beginAtZero: true,
                    max: this.maxInquiriesChartVal,
                    min: 0,
                    position: 'right',
                    color: 'red',
                    grid: {
                      color: '#ebeef0',
                      drawBorder: false
                    },
                    ticks: {
                      color: '#87939a',
                      font: {
                        family: 'Metropolis',
                        size: 10,
                        weight: '500'
                      }
                    },
                  },
                  x: {
                    grid: {
                      display: false
                    }
                  }
                },
                plugins: this.optionsPlugins
              }
            }));
          }, 1000)
        }
      });
    },
    loadCustomers () {
      Vue.set(this, 'customersInitiated', true);

      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/adviser/dashboard/customers',
        method: 'get',
        outputKey: 'customers',
        loadedKey: 'customersLoaded',
        errorKey: 'loadError',
        successAction: () => {
          setTimeout(() => {
            Vue.set(this, 'customersChart', new Chart(this.customersCtx, {
              type: 'bar',
              data: this.customersChartData,
              options: {
                animations: this.optionsAnimations,
                animation: {
                  onComplete: () => {
                    let ctx = this.customersChart.ctx;

                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    ctx.font = '500 16px Metropolis';
                    ctx.fillStyle = '#023047';

                    this.customersChartData.datasets.forEach((dataset, i) => {
                      let meta = this.customersChart.getDatasetMeta(i);
                      meta.data.forEach((bar, index) => {
                        let data = dataset.data[index];
                        ctx.fillText(data, bar.x, bar.y - 10);
                      });
                    });
                  }
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  y: {
                    display: true,
                    beginAtZero: true,
                    max: this.maxCustomersChartVal,
                    min: 0,
                    position: 'right',
                    color: 'red',
                    grid: {
                      color: '#ebeef0',
                      drawBorder: false
                    },
                    ticks: {
                      color: '#87939a',
                      font: {
                        family: 'Metropolis',
                        size: 10,
                        weight: '500'
                      }
                    },
                  },
                  x: {
                    grid: {
                      display: false
                    }
                  }
                },
                plugins: this.optionsPlugins
              }
            }));
          }, 1000)
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.v-select.minimal {
  top: -4px;
}

.dashboard-top-panel {
  display: flex;
  padding-top: 35px;

  padding-bottom: 30px;

  &-element {
    width: 50%;
  }

  .f-btn-dashboard {
    width: calc(50% - 5px);
  }

  .big-counter {
    color: $color-green;
    font-size: var(--font-size-title-big);
    font-weight: 600;
    line-height: $font-line-height-tiny;
    text-align: right;
  }
}

.dashboard-card-icon {
  background: $color-bg-grey;
  border-radius: 50%;
  height: 55px;
  width: 55px;

  .icon {
    fill: $color-light;
    max-height: 100%;
    max-width: 100%;
    padding: 14px;
  }

  & + div {
    margin-top: 2px;
  }
}

.dashboard-charts {
  &-card {
    width: calc((100% / 3) - 2.5rem);
  }

  .dashboard-chart-wrapper {
    background: $color-light;
    border-radius: 6px;
    box-shadow: $shadow-normal;
    height: 480px;
  }
}

.customer-dashboard {
  .buttons-container  {
    justify-content: space-between;

    .f-btn-dashboard {
      width: calc((100% / 4 - 20px));
    }
  }

  .f-btn-dashboard {
    .icon {
      fill: $color-primary;
    }
  }
}

@media screen and (max-width: $media-desktop-s) {
  .dashboard-top-panel {
    .f-btn-dashboard {
      width: 100%;
    }

    &.adviser-dashboard {
      .f-btn-dashboard:first-child {
        margin-bottom: 1rem;
      }
    }
  }

  .dashboard-card-icon {
    margin-right: 1rem!important;
  }
}


@media screen and (max-width: $media-tablet-xl) {
  .customer-dashboard .buttons-container {
    flex-wrap: wrap;
    margin-bottom: -2rem;

    .f-btn-dashboard {
      margin-bottom: 2rem;
      width: calc((100% / 2 - 1rem));
    }
  }
}

@media screen and (max-width: $media-tablet-l) {
  .dashboard-top-panel {
    flex-wrap: wrap;

    &-element {
      width: 100%;
    }
  }

  .dashboard-charts {
    &-card {
      width: calc(50% - 2rem);

      &:last-child {
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: $media-tablet-xs) {
  .dashboard-charts {
    &-card {
      width: 100%;
    }
  }
}

@media screen and (max-width: $media-phone-m) {
  .plain-card {
    padding: 20px 15px 15px 15px;
  }

  .dashboard-card-icon {
    height: 45px;
    width: 45px;

    .icon {
      padding: 10px;
    }
  }

  .dashboard-top-panel .f-btn-dashboard:first-child {
    margin-bottom: 2rem;
  }

  .customer-dashboard .buttons-container {
    margin-bottom: 0;

    .f-btn-dashboard {
      margin-bottom: 2rem;
      width: 100%;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
